import type {NumericType, SchemaType} from '../../../../../../../../utils/normalizeSchemaProperties'
import {isNumericType} from '../../../../../../../../utils/normalizeSchemaProperties'

const NUMERIC_TYPE_LABELS: Record<NumericType, string> = {
  integer: 'an integer',
  number: 'a number',
}

const INCOMPLETE_NUMBER_TAIL_REGEXP = /[.eE+-]+$/

export function getNumericTypeErrorMessage(types: readonly string[]): string | undefined {
  const numericType = types.find(isNumericType)

  return numericType != null
    ? `must be ${NUMERIC_TYPE_LABELS[numericType]} or a parameter reference`
    : undefined
}

/**
 * Keeps a numeric parameter numeric where possible. Anything that is not a number is stored as
 * typed, so parameter references such as `%build.counter%` keep working.
 */
export function parseNumericInput(rawValue: string): number | string | undefined {
  if (rawValue.trim() === '') {
    return undefined
  }

  const numericValue = Number(rawValue)

  return Number.isFinite(numericValue) ? numericValue : rawValue
}

function getTypeNames(schemaType: SchemaType): readonly string[] {
  if (Array.isArray(schemaType)) {
    return schemaType
  }

  return schemaType != null ? [schemaType] : []
}

export function getNumericValueError(
  value: string | number | undefined,
  schemaType: SchemaType,
): string | undefined {
  if (typeof value !== 'string' || value.includes('%')) {
    return undefined
  }

  // a value still being typed ('-', '1.', '2e') is not reported as invalid yet
  const completeValue = value.replace(INCOMPLETE_NUMBER_TAIL_REGEXP, '')

  if (completeValue.trim() === '' || Number.isFinite(Number(completeValue))) {
    return undefined
  }

  return getNumericTypeErrorMessage(getTypeNames(schemaType))
}
